module.exports = __webpack_public_path__ + "manageLink.9beace18.jpg";